<template>
    <div class="question">
        <div class="question-title">
            {{ question.problemName }}
        </div>
        <div class="question-score-wrap">
            <div class="question-score">
                <div class="question-score-item" @click="setScore(score)" :class="[
			  score === currentScore && `active`
			]" v-for="score in scoreMax">
                    {{ score }}
                </div>
            </div>
        </div>
        <div class="question-level mt-8 ml-20 mr-20">
            <span class="left">{{question.answerIndexOne}}</span>
            <span class="center"></span>
            <span class="right">{{question.answerIndexTwo}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name    : "QuestionContent",
        props   : {
            question: {
                type   : Object,
                default: () => ({})
            },
            scoreMax: {
                default: 5,
                type   : Number
            },
            value   : {
                default: 0,
                type   : Number
            }
        },
        computed: {
            currentScore: {
                get() {
                    return this.value;
                },
                set(score) {
                    this.$emit(`input`, score);
                }
            }
        },
        methods : {
            //设置值
            setScore(score) {
                this.currentScore = score;
            }
        }
    }
</script>

<style scoped lang="scss">
    .question {
        color: white;
        padding: 10px;

        .question-title {
            margin-bottom: 10px;
        }

        //分数外包围部分
        .question-score-wrap {
            padding: 0 20px;
        }

        //分数部分
        .question-score {
            display: flex;
            justify-content: center;
            text-align: center;
            border-radius: 20px;
            border: 1px solid white;
            overflow: hidden;
        }

        //分数项目
        .question-score-item {
            flex: 1;
            box-sizing: border-box;
            padding: 4px 0;

            &:not(:last-child) {
                border-right: 1px solid white;
            }

            &.active {
                background-color: white;
                color: black;
            }
        }
        .question-level {
            color: #999999;
            display: flex;
            flex-direction: row;

            .center {
                flex: 1;
            }
        }
    }
</style>